// User limits
export const MAX_ADDRESSES = 10;
